import { render } from "./NarrowContainer.vue?vue&type=template&id=d1fe3490&ts=true"
import script from "./NarrowContainer.vue?vue&type=script&lang=ts"
export * from "./NarrowContainer.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__